/**
 * SaaSFoundation API base URL for AgenticRCM shell.
 * Port 3000/3001 = direct SaaS dev; otherwise nginx proxies /api → SaaSFoundation:8001.
 */
export function getSaasApiBaseUrl() {
  if (typeof window !== 'undefined' && window.location) {
    const port = window.location.port;
    const hostname = window.location.hostname;

    if (
      (hostname === 'localhost' || hostname === '127.0.0.1') &&
      (port === '3000' || port === '3001')
    ) {
      return (() => { const __h = hostname; return (__h && __h !== 'localhost' && __h !== '127.0.0.1' && !/^(\d{1,3}\.){3}\d{1,3}$/.test(__h)) ? '/api/v1' : `http://${hostname}:8001/api/v1`; })();
    }

    return '/api/v1';
  }

  return '/api/v1';
}
